export enum LayoutEnum {
   ADMIN = 'AdminLayout',
   BASIC = 'BasicLayout',
   ORGANIZATION = 'OrganizationLayout',
   MAP = 'MapLayout',
   HOTEL = 'HotelLayout',
   BOOKING = 'BookingLayout',
   USER = 'UserLayout',
}
